// src/canonical-redirect.js
// Force canonical domain to prevent auth split between triviaplug.com and www.triviaplug.com
(function() {
  const CANON = "www.triviaplug.com";
  if ((window.location.host === "triviaplug.com" || window.location.host === "www.triviaplug.com") &&
      window.location.host !== CANON) {
    console.log("Redirecting to canonical domain:", CANON);
    window.location.replace(`${window.location.protocol}//${CANON}${window.location.pathname}${window.location.search}${window.location.hash}`);
  }
})();
